import { Swap } from './ApiTypes';

/**
 * 素材動画のタイトルと URL に対する部分一致。空白区切りの語をすべて含むものだけ通す。
 *
 * 素材が消えているスワップ（`original` を引けなかったもの）は、
 * 検索語があるときは対象から外す（照合できる文字列を持たないため）。
 */
export const matchesSwapQuery = (swap: Swap, text: string) => {
  const words = text.trim().toLowerCase().split(/\s+/).filter(word => word.length > 0);
  if (words.length === 0) {
    return true;
  }
  const original = swap.original;
  if (!original) {
    return false;
  }
  const target = `${original.detected.title} ${original.url}`.toLowerCase();
  return words.every(word => target.includes(word));
};
